import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import React, { forwardRef } from 'react';
// material
import { Box, CircularProgress, Dialog } from '@mui/material';

// ----------------------------------------------------------------------

const Page = forwardRef(({ children, title = '', openProgress, ...other }, ref) => (
  <Box ref={ref} {...other}>
    <Helmet>
      <title>{title}</title>
    </Helmet>
    {children}
    <Dialog
      PaperProps={{
        style: {
          backgroundColor: 'transparent',
          boxShadow: 'none',
          overflow: 'hidden'
        }
      }}
      open={openProgress === undefined ? false : openProgress}
    >
      <CircularProgress />
    </Dialog>
  </Box>
));

Page.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  openProgress: PropTypes.bool
};

export default Page;
